module.exports = __webpack_public_path__ + "media/images/font/Gustavo-BoldItalic-0eca2a4fc9d3e7d7daa77ac02b151df8.eot";